/**
 * 커뮤니티 게시판(소주제). 글은 반드시 하나에 속한다. 키는 저장값이라 바꾸지 않는다.
 * 순서가 곧 화면 순서다.
 */
export const COMMUNITY_TOPICS = [
    { key: 'dailylife', label: '소소한 일상사' },
    { key: 'bounty', label: '꽁돈 찾는 바운티 헌터즈' },
    { key: 'startup', label: '좋소기업 생존기' },
    { key: 'hell', label: '창업 지옥' },
    { key: 'some', label: '돈 타면 썸도 탄다' },
    { key: 'collaboration', label: '콜라보 기회 찾기' },
];
export const COMMUNITY_TOPIC_KEYS = COMMUNITY_TOPICS.map((t) => t.key);
export const topicLabel = (key) => COMMUNITY_TOPICS.find((t) => t.key === key)?.label ?? '커뮤니티';
//# sourceMappingURL=community.js.map